Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var index_1 = require("./consts/index");
var GoogleMap = /** @class */ (function (_super) {
    tslib_1.__extends(GoogleMap, _super);
    function GoogleMap() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GoogleMap.prototype.render = function () {
        return (React.createElement("iframe", { style: { width: this.props.width, height: this.props.height }, allowFullScreen: true, frameBorder: "0", className: 'google-map', src: this.sourceString }));
    };
    Object.defineProperty(GoogleMap.prototype, "sourceString", {
        get: function () {
            var locationPartial = "&q=" + this.props.marker.lat + "," + this.props.marker.lng;
            var zoomPartial = !!this.props.zoom ? "&zoom=" + this.props.zoom : '';
            var satellitePartial = !!this.props.isSatellite ? '&maptype=satellite' : '';
            var languagePartial = '&language=ru';
            return "https://www.google.com/maps/embed/v1/place?key=" + index_1.GOOGLE_MAPS_API_KEY + locationPartial + zoomPartial + satellitePartial + languagePartial;
        },
        enumerable: true,
        configurable: true
    });
    return GoogleMap;
}(React.Component));
exports.GoogleMap = GoogleMap;
